import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-header',
  templateUrl: './candidate-header.component.html',
  styleUrls: ['./candidate-header.component.scss']
})
export class CandidateHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

  helpClick(): void {
    window.open('https://help.evaltrix.com/product/collection/take-an-assessment-test', '_blank');
  }

}
